import store from '../../store/index'

let loadingReqCount = 0
function start (msg) {
  msg = msg == null || msg === '' ? '加载中...' : msg
  store.commit('showLoading', msg)
}

function end () {
  if (store.state.loadingShowTag) {
    store.commit('hideLoading')
  }
}

let CyLoading = {
  startLoading: function (msg) {
    if (loadingReqCount === 0) {
      start(msg)
    }
    loadingReqCount++
  },

  endLoading: function () {
    if (loadingReqCount <= 0) return
    loadingReqCount--
    if (loadingReqCount === 0) {
      end()
    }
  }
}

let CyMsgBox = {
  alert: function (msg, title) {
    store.commit('showAlert', msg, title)
  }
}

export {
  CyLoading,
  CyMsgBox
}



// WEBPACK FOOTER //
// ./src/assets/js/tiptool.js